jQuery(document).ready(function($) {
  $('.dev-select-option select').change(function(event) {
    //     console.log($(this).val());
    // 		$('input[value='+$(this).val()+']').attr('checked', true);
    $('input[value="'+$(this).val()+'"]').trigger('click');
  });

  // $('.product-customizer-options .product-customizer-option:not(.conditional-logic-hidden) select').each(function(index, el) {
  // 	// console.log( $(this).val() );
  // 	$( this ).children('option:selected').text();
  // 	console.log( $( this ).children('option:selected').text() );
  // });

  $('.dev-select-option select, .product-customizer-options select').change(function(){
    let productDefaultPrice = $('#ProductPrice-product-template span.money').first().text();
    productDefaultPrice = Number(productDefaultPrice.slice(1));
    let customizerPrice = $('.product-customizer-customizations-total span').first().text();
    customizerPrice = Number(customizerPrice.slice(1));
	let devTotalPrice = customizerPrice + productDefaultPrice;
    devTotalPrice = devTotalPrice.toFixed(2);
    //     console.log( productDefaultPrice );
    //     console.log( customizerPrice );
    $('#dev-custom-price span').text('$' + devTotalPrice);
  });

});